import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abcdeb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "between-center flex1" }
const _hoisted_2 = { class: "center-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增用户 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 批量编辑 ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-contianer" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 二维码和链接 30 分钟内有效，用户注册账号后会绑定为贵公司的子账号，请谨慎出示 ", -1))
const _hoisted_11 = { class: "add_user_entry main-between" }
const _hoisted_12 = { class: "add_qrCode add_user_entry_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "type_name" }, "邀请员工扫码绑定", -1))
const _hoisted_14 = { class: "type_content" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separate" }, null, -1))
const _hoisted_17 = { class: "add_link add_user_entry_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "type_name" }, "复制分享链接", -1))
const _hoisted_19 = { class: "type_content" }
const _hoisted_20 = {
  key: 1,
  class: "add_user_entry center-center",
  style: {"height":"370px"}
}
const _hoisted_21 = { class: "overdue center-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "overdue-span" }, "二维码&链接已失效", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 点击刷新 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_DefaultOptionSelect = _resolveComponent("DefaultOptionSelect")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AdminTableLayout, {
      formData: _ctx.formData,
      formLabelWidth: 100,
      searchDisabled: _ctx.loading,
      onSearch: _ctx.onSearchHandle
    }, {
      "search-info": _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "员工姓名",
              prop: "staffName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入员工姓名",
                  modelValue: _ctx.formData.staffName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.staffName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "员工手机号",
              prop: "staffPhone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入员工手机号",
                  type: "number",
                  modelValue: _ctx.formData.staffPhone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.staffPhone) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "账号状态",
              prop: "accountStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DefaultOptionSelect, {
                  "dictionary-key": "merchant_user_data_status",
                  "has-all": "",
                  modelValue: _ctx.formData.accountStatus,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.accountStatus) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      "content-header": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header-nav", {}, undefined, true),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              class: "system-btn",
              type: "primary",
              size: "mini",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleAddStaff()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "system-btn",
              size: "mini",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleBatchEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ])
      ]),
      "content-table": _withCtx(() => [
        _hoisted_5,
        _createVNode(_component_ReportTable, {
          loading: _ctx.loading,
          tableData: _ctx.tableData,
          showTableColumn: _ctx.showTableColumn,
          onChangeSelection: _ctx.handleSelect
        }, {
          actions: _withCtx(({ row }) => [
            (
              _ctx.roleTypeList.includes(1) &&
              row.roleType.indexOf('普通管理员') > -1
            )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    style: {"margin-right":"16px"},
                    onClick: ($event: any) => (_ctx.handleEdit(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (row.isEnabled == '1')
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 0,
                        type: "primary",
                        style: {"margin-right":"16px"},
                        onClick: ($event: any) => (_ctx.handleEnable(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (row.isEnabled == '0')
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 1,
                        type: "primary",
                        style: {"margin-right":"16px"},
                        onClick: ($event: any) => (_ctx.handleEnable(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_link, {
                    type: "primary",
                    onClick: ($event: any) => (_ctx.handleDelete(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ], 64))
          ]),
          _: 1
        }, 8, ["loading", "tableData", "showTableColumn", "onChangeSelection"])
      ]),
      "foot-pagination": _withCtx(() => [
        _createVNode(_component_el_pagination, {
          class: "system-pagination",
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.totalNum,
          "page-sizes": _ctx.pageSizeList,
          "current-page": _ctx.pageNum,
          "onUpdate:current-page": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageSize) = $event)),
          onCurrentChange: _ctx.currentPageChangeHandle,
          onSizeChange: _ctx.sizeChangeHandle
        }, null, 8, ["total", "page-sizes", "current-page", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 3
    }, 8, ["formData", "searchDisabled", "onSearch"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "新增用户",
      width: "800px"
    }, {
      default: _withCtx(() => [
        (_ctx.dueFlag == 'true')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("img", {
                      src: _ctx.addUserInfo.qrCode,
                      alt: ""
                    }, null, 8, _hoisted_15)
                  ]),
                  (_ctx.dueFlag == 'true')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "button-save button-item",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDownPic && _ctx.handleDownPic(...args)))
                      }, " 保存图片 "))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.addUserInfo.link), 1),
                  (_ctx.dueFlag == 'true')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "button-copy button-item",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleCopyLink && _ctx.handleCopyLink(...args)))
                      }, " 复制链接 "))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_el_button, {
                  class: "system-btn",
                  type: "primary",
                  size: "mini",
                  onClick: _ctx.handleRefreshToken
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}